import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';

import { LOCALE_ID } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { tokenInterceptor } from './app/interceptors/token.interceptor';

// Registrar o locale 'pt-BR'
registerLocaleData(localePt);

appConfig.providers.push({ provide: LOCALE_ID, useValue: 'pt-BR' }); // Adicionar o provider do LOCALE_ID
appConfig.providers.push(provideHttpClient(
  withInterceptors( [tokenInterceptor] )
))

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);
